import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';
import { fetchEmployers } from 'Features/Organization/organizationSlice';
import { RootState } from 'Store';

const Container = styled.div`
  margin-top: 16px;
  background-color: #ffffff;
  box-shadow: 0 7px 7px -10px rgba(0, 0, 0, 0.41);
  padding: 20px 15px!important;
  border-radius: 6px;
`;

const Title = styled.h3`
  color: #252525;
  font-family: acumin-pro;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
  margin: 0 0 16px;
`;

const EmployerList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 200px;
  overflow-y: auto;
`;

const EmployerItem = styled.li`
  color: #d73714;
  font-family: acumin-pro;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  margin-bottom: 8px;
`;

const AllEmployers = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { employers } = useSelector((state: RootState) => state.organization);

  useEffect(() => {
    dispatch(fetchEmployers());
  }, [dispatch]);

  return (
    <Container>
      <Title>{t('all-employers-second')}</Title>
      <EmployerList>
        {employers
          .filter((employer) => !employer.is_household)
          .map((employer) => (
            <EmployerItem key={employer.id}>{employer.name}</EmployerItem>
          ))}
      </EmployerList>
    </Container>
  );
};

export default AllEmployers;
